import Swiper, { Pagination, Autoplay, Navigation } from 'swiper';

Swiper.use([Pagination, Autoplay, Navigation]);

const swiper = new Swiper('.works__swiper', {
  slidesPerView: 4,
  spaceBetween: 35,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    701: {
      slidesPerView: 2,
    },
    1001: {
      slidesPerView: 3,
    },
    1201: {
      slidesPerView: 4,
    }
  },
});

const swiperS = new Swiper('.stages__swiper', {
  spaceBetween: 15,
  loop: true,
  spaceBetween: 15,
  autoplay: {
    delay: 500,
    disableOnInteraction: false,
  },
  breakpoints: {
    320: {
      slidesPerView: 2,
    },

    450: {
      slidesPerView: 3,
    },

    550: {
      slidesPerView: 4,
    },
    700: {
      slidesPerView: 5,
    },
    900: {
      slidesPerView: 6,
    },
    1100: {
      slidesPerView: 7,
    },
    1200: {
      slidesPerView: 8,
    }
  },
});



let swiperT = null;

function initTabsSwiper() {
  const screenWidth = window.innerWidth;
  const swiperEl = document.querySelector('.tabs__swiper');

  if (!swiperEl) return;

  if (screenWidth < 1000 && !swiperT) {
    swiperT = new Swiper('.tabs__swiper', {
      spaceBetween: 15,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        600: {
          slidesPerView: 2,
        },
      },
    });

    setTimeout(() => swiperT.update(), 100); // обновить после отрисовки
  } else if (screenWidth >= 1000 && swiperT) {
    swiperT.destroy(true, true);
    swiperT = null;
  }
}

// Добавляем слушатели один раз, вне функции
window.addEventListener('load', initTabsSwiper);

window.addEventListener('resize', () => {
  clearTimeout(window.resizedFinished);
  window.resizedFinished = setTimeout(initTabsSwiper, 150);
});


